import FeaturedPropertiesContainer from './FeaturedPropertiesContainer';

export default FeaturedPropertiesContainer;
